import Vue from "vue";
import Router from "vue-router";
import mytask from "@/router/myTask";
import queryByProduct from "@/router/queryByProduct";
import visitPlan from "@/router/visitPlan";
import supplierManage from "@/router/supplierManage";
import settlementUnit from "@/router/settlementUnit";

import storeFeedback from "@/router/storeFeedback";
import sensory from "@/router/sensory";
import sensory2 from "@/router/sensory2";
import system from "@/router/system";
import ssrManage from "@/router/ssrManage";
import capacity from "@/router/capacity";
import BC from "@/router/BCManage";
import rfpManage from "@/router/rfpManage";
import fpaManage from "@/router/fpaManage";
import spm from "@/router/spm";
import material from "@/router/material";
import DC from "@/router/DC";
import QSPI from "@/router/QSPI";
import QBR from "@/router/QBR";
import AAA from "@/router/AAA";
import DQMP from "@/router/DQMP";
import FSPI from "@/router/FSPI";
import QIP from "@/router/QIP";
import ReceiveVolume from "@/router/ReceiveVolume";
import stockRecovery from "@/router/stockRecovery";
import OtherTargetMaintain from "@/router/OtherTargetMaintain";
import rmcProduce from "@/router/rmcProduce";
import qspiReport from "@/router/qspiReport";
import rmcProtein from "@/router/rmcProtein";
import Nutrition from "@/router/Nutrition";
import productManagement from "@/router/productManagement";

Vue.use(Router);
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch((err) => err);
};
const loginRouter = () => {
    var nodeEnv = process.env.NODE_ENV;
    if (nodeEnv == "production") {
        return [{
            path: "/login",
            redirect: "/myTask",
        },
        {
            path: "/splogin",
            component: () =>
                import("../components/page/sp-login.vue"),
        },
        {
            path: "/ssologin",
            component: () =>
                import("../components/page/ssoLogin.vue"),
        },
        ];
    } else {
        return [{
            path: "/login",
            component: () =>
                import("../components/page/login.vue"),
        },
        {
            path: "/ssologin",
            component: () =>
                import("../components/page/ssoLogin.vue"),
        },
        {
            path: "/splogin",
            component: () =>
                import("../components/page/sp-login.vue"),
        },
        ];
    }
};

const router = new Router({
    routes: [{
        path: "/",
        redirect: "/mydashboard",
    },
    {
        path: "/",
        component: () =>
            import("../components/common/home.vue"),
        meta: { title: "自述文件" },
        children: [{
            path: "/dashboard",
            component: () =>
                import("../components/page/dashboard.vue"),
            meta: { title: "nav.home" }, //首页
        },
        {
            path: "/count",
            component: () =>
                import("@/components/page/count/list.vue"),
            meta: { title: "试算" }, //试算
        },
        {
            path: "/count-datail",
            name: "countDatail",
            component: () =>
                import("@/components/page/count/detail.vue"),
            meta: { title: "运费试算" }, //试算详情
        },
        {
            path: "/material-rack",
            component: () =>
                import(
                    "../components/page/main-data/material-rack/material-rack.vue"
                ),
            meta: { title: "料架主数据" },
        },
        {
            path: "/material-rack-edit",
            name: "material-rack-edit",
            component: () =>
                import(
                    "../components/page/main-data/material-rack/material-rack-edit.vue"
                ),
            meta: { title: "料架主数据详细/修改页面" },
        },
        {
            path: "/route-node",
            component: () =>
                import("../components/page/main-data/route-node/route-node.vue"),
            meta: { title: "库存节点" },
        },
        {
            path: "/route-node-edit",
            name: "inventory-node-edit",
            component: () =>
                import(
                    "../components/page/main-data/route-node/route-node-edit.vue"
                ),
            meta: { title: "库存节点详细/修改页面" },
        },
        {
            path: "/mate-code",
            component: () =>
                import("../components/page/main-data/mate-code/mate-code.vue"),
            meta: { title: "料架唯一编号" },
        },
        {
            path: "/mate-part",
            component: () =>
                import("../components/page/main-data/mate-part/mate-part.vue"),
            meta: { title: "料架物料对应关系" },
        },
        {
            path: "/box-list",
            component: () =>
                import("../components/page/store-manage/box-list.vue"),
            meta: { title: "装箱单信息" },
        },
        {
            path: "/out-store-order",
            component: () =>
                import(
                    "../components/page/store-manage/out-store/out-store-order.vue"
                ),
            meta: { title: "出库单管理" },
        },
        {
            path: "/out-store-order-edit",
            name: "out-store-order-edit",
            component: () =>
                import(
                    "../components/page/store-manage/out-store/out-store-order-edit.vue"
                ),
            meta: { title: "出库单详细/创建/编辑页面" },
        },
        {
            path: "/store-list",
            component: () =>
                import("../components/page/store-manage/store-list.vue"),
            meta: { title: "库存查询" },
        },
        {
            path: "/material-rack-item",
            component: () =>
                import("../components/page/store-manage/material-rack-item.vue"),
            meta: { title: "料架个体查询" },
        },
        {
            path: "/abnormal-mate",
            component: () =>
                import("../components/page/store-manage/abnormal-mate.vue"),
            meta: { title: "异常料架报表" },
        },
        {
            path: "/activiti-model",
            component: () =>
                import("../components/page/system/activiti/activiti-model"),
            meta: { title: "模型控制" },
        },
        {
            path: "/activiti-deployment",
            component: () =>
                import("../components/page/system/activiti/activiti-deployment"),
            meta: { title: "流程控制" },
        },
        {
            path: "/supplier", //供应商
            component: () =>
                import("../components/page/base-data/supplier.vue"),
            meta: { title: "nav.supplierData" },
        },
        {
            path: "/carrier", //承运商
            component: () =>
                import("../components/page/base-data/carrier.vue"),
            meta: { title: "nav.carrierData" },
        },
        {
            path: "/carrier-add", //承运商新增
            name: "carrier-add",
            component: () =>
                import("../components/page/base-data/carrier-add.vue"),
            meta: { title: "nav.carrierDataNew" },
        },
        {
            path: "/carrier-modify", //承运商修改
            name: "carrier-modify",
            component: () =>
                import("../components/page/base-data/carrier-modify.vue"),
            meta: { title: "nav.carrierDataEdt" },
        },
        {
            path: "/supplier-add", //供应商新增（不要）
            name: "supplier-add",
            component: () =>
                import("../components/page/base-data/supplier-add.vue"),
            meta: { title: "nav.supplierDataNew" },
        },
        {
            path: "/sourcing",
            name: "sourcing",
            component: () =>
                import("../components/page/quotation-apply/sourcing.vue"),
            meta: { title: "nav.fixedPointLineQuotation" }, //线路报价确认
        },
        {
            path: "/sourcing-detail",
            name: "sourcingDetail",
            component: () =>
                import("../components/page/quotation-apply/sourcing-detail.vue"),
            meta: { title: "common.details" }, //线路报价确认明细
        },
        {
            path: "/applyShow/:ttQuotationApplyId",
            name: "applyShow",
            component: () =>
                import("../components/page/quotation-apply/apply-detail-show.vue"),
            meta: { title: "common.details" },
        },
        {
            path: "/linePriceData",
            name: "linePriceData",
            component: () =>
                import("../components/page/base-data/linePriceData.vue"),
            meta: { title: "nav.linePriceData" }, //线路价格主数据
        },
        {
            path: "/linePriceData-Detail/:tmPickupId/:temperature/:tmDcId/:transportaionMethod",
            name: "linePriceDetail",
            component: () =>
                import("../components/page/base-data/linePriceDataDetail"),
            meta: { title: "common.details" },
        },
        {
            path: "/materialPriceData",
            name: "materialPriceData",
            component: () =>
                import("@/components/page/base-data/materialPriceData"),
            meta: { title: "物料运费价格主数据" },
        },
        {
            path: "/materialPriceData-history",
            name: "materialPriceHistory",
            component: () =>
                import("@/components/page/base-data/materialPriceHistory"),
            meta: { title: "产品运费价格历史查看" }, //物料运费价格主数据查看历史
        },

        ...mytask,
        {
            path: "/user-manage",
            component: () =>
                import("../components/page/user-manage/user-manage.vue"),
            meta: { title: "nav.userManagement" }, //用户管理
        },
        {
            path: "/role-manage",
            component: () =>
                import("../components/page/user-manage/role-manage.vue"),
            meta: { title: "nav.roleManagement" }, //角色管理
        },
        {
            path: "/function-manage",
            component: () =>
                import("../components/page/user-manage/function-manage.vue"),
            meta: { title: "nav.functionManagement" }, //权限管理
        },
        {
            path: "/dc",
            component: () =>
                import("../components/page/base-data/dc.vue"),
            meta: { title: "nav.arrivalWarehouse" }, //DC主数据
        },
        {
            path: "/pickup-point",
            component: () =>
                import("../components/page/base-data/pickup-point.vue"),
            meta: { title: "nav.pickUpPoint" }, //提货点
        },
        {
            path: "/plant",
            component: () =>
                import("../components/page/base-data/plant.vue"),
            meta: { title: "nav.plant" }, //工厂
        },
        {
            path: "/material",
            name: "material",
            component: () =>
                import("../components/page/base-data/material.vue"),
            meta: { title: "物料运输主数据" },
        },
        {
            path: "/material-detail",
            name: "materialDetail",
            component: () =>
                import("../components/page/base-data/materialDetail.vue"),
            meta: { title: "物料运输主数据详情" },
        },
        {
            path: "/product-quotation-application",
            name: "productQuotationApplication",
            component: () =>
                import(
                    "@/components/page/quote-by-product/productQuotationApplication/productQuotationApplication.vue"
                ),
            meta: { title: "nav.productQuotationApplication" }, //产品报价申请单
        },
        ...queryByProduct,
        {
            path: "/inquiry-quotation-product",
            name: "inquiryQuotationProduct",
            component: () =>
                import(
                    "@/components/page/quote-by-product/inquiryQuotationProduct/inquiryQuotationProduct.vue"
                ),
            meta: { title: "询报价(产品)" }, //询报价（产品）
        },
        {
            path: "/inquiry-quotation-product-detail",
            name: "inquiryQuotationProductDetail",
            component: () =>
                import(
                    "@/components/page/quote-by-product/inquiryQuotationProduct/detail.vue"
                ),
            meta: { title: "详情" },
        },
        {
            path: "/sourcingByProduct",
            name: "sourcingByProduct",
            component: () =>
                import(
                    "../components/page/quote-by-product/sourcingByProduct/list.vue"
                ),
            meta: { title: "产品报价确认" }, //产品报价确认列表
        },
        {
            path: "/sourcingByProduct-detail",
            name: "sourcingByProductDetail",
            component: () =>
                import(
                    "@/components/page/quote-by-product/sourcingByProduct/detail.vue"
                ),
            meta: { title: "quote.sourcingProduct.detailTitle" }, //报价确认明细界面
        },
        {
            path: "/inquiry-quotation-product-submit",
            name: "inquiryQuotationProductSubmit",
            component: () =>
                import(
                    "@/components/page/quote-by-product/sourcingByProduct/submit.vue"
                ),
            meta: { title: "产品报价确认" }, //报价确认 提交
        },
        {
            path: "/inquiry-quotation-product-history",
            name: "quotationProductHistory",
            component: () =>
                import(
                    "@/components/page/quote-by-product/inquiryQuotationProduct/history.vue"
                ),
            meta: { title: "历史报价查看" }, //历史报价查看
        },
        {
            path: "/product-quotation-application-add",
            name: "productQuotationApplicationAdd",
            component: () =>
                import(
                    "@/components/page/quote-by-product/productQuotationApplication/productQuotationApplicationAdd.vue"
                ),
            meta: { title: "详情" }, //按产品报价申请单-创建
        },
        {
            path: "/materialPriceData-priceChange",
            name: "priceChange",
            component: () =>
                import(
                    "@/components/page/quote-by-product/productQuotationApplication/priceChange.vue"
                ),
            meta: { title: "产品价格变更" }, //产品价格变更
        },
        {
            path: "/apply",
            name: "apply",
            component: () =>
                import("../components/page/quotation-apply/apply.vue"),
            meta: { title: "nav.lineQuotationApplication" }, //线路报价申请单
        },
        {
            path: "/apply-detail/:applyId/:source/:applyType?",
            name: "applyDetail",
            component: () =>
                import("../components/page/quotation-apply/apply-detail.vue"),
            meta: { title: "common.details" },
        },
        {
            path: "/apply-change/:applyIde/:source",
            name: "applyChangeLine", //线路变更
            component: () =>
                import("../components/page/quotation-apply/apply-change-line.vue"),
            meta: { title: "nav.lineChange" },
        },
        {
            path: "/quotation",
            name: "quotation",
            component: () =>
                import("../components/page/quotation-apply/quotation-search.vue"),
            meta: { title: "nav.inquiryQuotationLine" }, //询报价(线路)
        },
        {
            path: "/quotation-detail/:roundId/:from",
            name: "quotationDetail",
            component: () =>
                import("../components/page/quotation-apply/quotation-detail.vue"),
            meta: { title: "common.details" },
        },
        {
            path: "/quotation-history/:applyId",
            name: "quotationHistory",
            component: () =>
                import("../components/page/quotation-apply/quotation-history.vue"),
            meta: { title: "apply.quoteHistory" },
        },
        {
            path: "/sourcing-submit",
            name: "sourcingSubmit",
            component: () =>
                import("../components/page/quotation-apply/sourcing-select.vue"),
            meta: { title: "apply.confirmPrice" },
        },
        //供应商端
        {
            path: "/apply-sp",
            name: "applySp",
            component: () =>
                import("../components/page/quotation-apply-sup/apply.vue"),
            meta: { title: "nav.lineQuotationApplication" },
        },
        {
            path: "/apply-sp-detail/:applyId/:source/:applyType?",
            name: "applySpDetail",
            component: () =>
                import("../components/page/quotation-apply-sup/apply-detail.vue"),
            meta: { title: "common.details" },
        },
        {
            path: "/quotation-sp",
            name: "quotationSp",
            component: () =>
                import(
                    "../components/page/quotation-apply-sup/quotation-search.vue"
                ),
            meta: { title: "nav.inquiryQuotationLine" },
        },
        {
            path: "/quotation-sp-detail/:roundId",
            name: "quotationSpDetail",
            component: () =>
                import(
                    "../components/page/quotation-apply-sup/quotation-detail.vue"
                ),
            meta: { title: "common.details" },
        },
        {
            path: "/quotation-sp-history/:applyId",
            name: "quotationSpHistory",
            component: () =>
                import(
                    "../components/page/quotation-apply-sup/quotation-history.vue"
                ),
            meta: { title: "报价历史" },
        },
        {
            path: "/product-quotation-application-sp",
            name: "productQuotationApplicationSp",
            component: () =>
                import(
                    "@/components/page/quote-by-product-sup/productQuotationApplication/productQuotationApplication.vue"
                ),
            meta: { title: "nav.productQuotationApplication" }, //产品报价申请单(sup)
        },
        {
            path: "/product-quotation-application-sp-add",
            name: "productQuotationApplicationAdd",
            component: () =>
                import(
                    "@/components/page/quote-by-product-sup/productQuotationApplication/productQuotationApplicationAdd.vue"
                ),
            meta: { title: "详情" }, //按产品报价申请单-创建
        },
        {
            path: "/inquiry-quotation-product-sp",
            name: "inquiryQuotationProductSp",
            component: () =>
                import(
                    "@/components/page/quote-by-product-sup/inquiryQuotationProduct/inquiryQuotationProduct.vue"
                ),
            meta: { title: "询报价(产品)" }, //询报价（产品）
        },
        {
            path: "/inquiry-quotation-product-sp-detail",
            name: "inquiryQuotationProductDetailsp",
            component: () =>
                import(
                    "@/components/page/quote-by-product-sup/inquiryQuotationProduct/detail.vue"
                ),
            meta: { title: "详情" },
        },
        {
            path: "/inquiry-quotation-product-sp-history",
            name: "inquiryQuotationProductsphistory",
            component: () =>
                import(
                    "@/components/page/quote-by-product-sup/inquiryQuotationProduct/history.vue"
                ),
            meta: { title: "报价历史" },
        },
        ...visitPlan,
        ...storeFeedback,
        ...sensory,
        ...sensory2,
        ...system,
        ...supplierManage,
        ...settlementUnit,
        ...ssrManage,
        ...capacity,
        ...BC,
        ...rfpManage,
        ...fpaManage,
        ...spm,
        ...material,
        ...DC,
        ...QSPI,
        ...QBR,
        ...AAA,
        ...DQMP,
        ...FSPI,
        ...QIP,
        ...stockRecovery,
        ...ReceiveVolume,
        ...OtherTargetMaintain,
        ...rmcProduce,
        ...rmcProtein,
        ...qspiReport,
        ...Nutrition,
        ...productManagement,
        ],
    },
    ...loginRouter(),
    {
        path: "/common-audit",
        name: "commonAudit",
        component: () =>
            import("@/components/page/common-audit"),
        meta: { title: "common.audit" },
    },
    {
        path: "/gallery",
        name: "gallery",
        component: () =>
            import("@/components/page/gallery"),
        meta: { title: "图片" },
    },
    {
        path: "*",
        redirect: "/404",
    },
    ],
});

export default router;